// extracted by mini-css-extract-plugin
export default {"outer":"parcours_outer__Q75Fv","inner":"parcours_inner__66844","name":"parcours_name__uQNFy"};